module.exports = __webpack_public_path__ + "static/img/组织架构.c04ff4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/组织架构.png
// module id = FuHa
// module chunks = 1